import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom';
import apiClient from '../../../utils/apiclient';

const Transactions = (route) => {
    const [data,setData]= useState([])
    const navigate = useNavigate()
  useEffect(() => {
    const tableData = async () => {
      console.log(route.route)
      try {

        const response = await apiClient.get(
 `${route.route}`        );
          console.log(response.data)
        setData(response.data);
      } catch (e) {
        console.error(e);
      }
    };
    tableData();
  }, [route.route]);
   return (
    <div className="w-full flex-1 flex flex-col min-h-0">
      <div className="flex justify-between items-center mb-2 flex-shrink-0 gap-3">
        <h2 className="text-base md:text-xl font-semibold text-gray-800 whitespace-nowrap">Transactions</h2>
      </div>
      <div className="w-full flex-1 overflow-auto pb-4 relative">
        <table className='min-w-max w-full bg-white shadow-md border-collapse'>
        <thead className="bg-gray-800 text-white sticky top-0 z-20 shadow-md">
      <tr>
        <th className="px-2 md:px-5 py-2 md:py-3 text-[10px] md:text-sm">Id
        </th>
        <th>
          Public id
        </th>
        <th>
          user id</th>
        <th className="px-2 md:px-5 py-2 md:py-3 text-[10px] md:text-sm" >amount</th>
        <th className="px-2 md:px-5 py-2 md:py-3 text-[10px] md:text-sm" >referralBonus</th>
        <th className="px-2 md:px-5 py-2 md:py-3 text-[10px] md:text-sm" >transactionType</th>
     
        <th className="px-2 md:px-5 py-2 md:py-3 text-[10px] md:text-sm">createdAt</th>
      </tr>
      </thead>
      <tbody>
        {
          data.map((data,index)=>(
        
            <tr key={index} className='items-center justify-center border border-gray-300'>
              <td className="px-2 md:px-5 py-2 text-[10px] md:text-sm text-center">{data.id}</td>
               <td className="px-2 md:px-5 py-2 text-[10px] md:text-sm text-center">{data.publicId}</td>
              {/* <td className="px-2 md:px-5 py-2 text-[10px] md:text-sm text-center hover:text-blue-900 hover:cursor-pointer" onClick={()=>{navigate(`/userDetails/${data.number}`)}}>{data.number}</td> */}
              <td className="px-2 md:px-5 py-2 text-[10px] md:text-sm text-center">{data.userId}</td>
              {/* <td className="px-2 md:px-5 py-2 text-[10px] md:text-sm text-center hover:text-blue-900 hover:cursor-pointer hover:underline" onClick={()=>{navigate(`/restaurant/${data.restaurantid}`)}}>{data.restaurantName}</td> */}
              <td className="px-2 md:px-5 py-2 text-[10px] md:text-sm text-center">{data.amount}</td>
              <td className="px-2 md:px-5 py-2 text-[10px] md:text-sm text-center">{data.referralBonus ? "Applied":"Not Applied"}</td>
             
           
            
              <td className="px-2 md:px-5 py-2 text-[10px] md:text-sm text-center">{data.transactionType}</td>
                          
              <td className="px-2 md:px-5 py-2 text-[10px] md:text-sm text-center pr-2">{data.createdAt}</td>
             

            </tr>
          ))
        }
        </tbody>
        </table>
      </div>
        </div>
  )
}

export default Transactions